<template>
  <div class="container mt-5">
    <div class="card p-4 shadow border-0" style="border-radius: 16px;">
      <h4 class="mb-4" style="color: #b03a45;">
        {{ $t("professionalInfo.title") }}
      </h4>

      <form @submit.prevent="handleSubmit">
        <div class="row">
          <!-- Company -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.company") }}
              </label>
              <select v-model="form.company_id" class="form-select">
                <option disabled value="">{{ $t("professionalInfo.placeholders.select") }}</option>
                <option v-for="company in companies" :key="company.id" :value="company.id">
                  {{ company.english_name }}
                </option>
              </select>
            </div>
          </div>

          <!-- Project -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.project") }}
              </label>
              <select v-model="form.project_id" class="form-select">
                <option disabled value="">{{ $t("professionalInfo.placeholders.select") }}</option>
                <option v-for="project in projects" :key="project.id" :value="project.id">
                  {{ project.name }}
                </option>
              </select>
            </div>
          </div>

          <!-- Position -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.position") }}
              </label>
              <select v-model="form.position_id" class="form-select">
                <option disabled value="">{{ $t("professionalInfo.placeholders.select") }}</option>
                <option v-for="position in positions" :key="position.id" :value="position.id">
                  {{ position.english_name }}
                </option>
              </select>
            </div>
          </div>

          <!-- Manager -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.manager") }}
              </label>
              <select v-model="form.manager_id" class="form-select">
                <option disabled value="">{{ $t("professionalInfo.placeholders.select") }}</option>
                <option v-for="manager in managers" :key="manager.id" :value="manager.id">
                  {{ manager.firstname }} {{ manager.lastname }}
                </option>
              </select>
            </div>
          </div>

          <!-- Supervisor -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.supervisor") }}
              </label>
              <select v-model="form.supervision_id" class="form-select">
                <option disabled value="">{{ $t("professionalInfo.placeholders.select") }}</option>
                <option v-for="supervisor in supervisors" :key="supervisor.id" :value="supervisor.id">
                  {{ supervisor.firstname }} {{ supervisor.lastname }}
                </option>
              </select>
            </div>
          </div>

          <!-- Hire Date -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.hireDate") }}
              </label>
              <input v-model="form.hire_date" type="date" class="form-control" />
            </div>
          </div>

          <!-- CIN -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.cin") }}
              </label>
              <input v-model="form.cin" type="text" class="form-control"
                     :placeholder="$t('professionalInfo.placeholders.cin')" />
            </div>
          </div>

          <!-- CIN Release Date -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.cinReleaseDate") }}
              </label>
              <input v-model="form.cin_release_date" type="date" class="form-control" required />
            </div>
          </div>

          <!-- CNSS -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.cnss") }}
              </label>
              <input v-model="form.cnss" type="text" class="form-control"
                     :placeholder="$t('professionalInfo.placeholders.cnss')" />
            </div>
          </div>

          <!-- Employee Code -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.employeeCode") }}
              </label>
              <input v-model="form.code" type="text" class="form-control"
                     :placeholder="$t('professionalInfo.placeholders.employeeCode')" />
            </div>
          </div>

          <!-- Work Number -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.workNumber") }}
              </label>
              <input v-model="form.work_number" type="text" class="form-control"
                     :placeholder="$t('professionalInfo.placeholders.workNumber')" />
            </div>
          </div>

          <!-- Work Email -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.workEmail") }}
              </label>
              <input v-model="form.work_email" type="email" class="form-control"
                     :placeholder="$t('professionalInfo.placeholders.workEmail')" />
            </div>
          </div>

          <!-- Diploma Type -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.diplomaType") }}
              </label>
              <select v-model="form.diploma_type" class="form-select">
                <option disabled value="">{{ $t("professionalInfo.placeholders.select") }}</option>
                <option value="PhD">{{ $t("professionalInfo.diplomas.phd") }}</option>
                <option value="Master">{{ $t("professionalInfo.diplomas.master") }}</option>
                <option value="Engineering">{{ $t("professionalInfo.diplomas.engineering") }}</option>
                <option value="License">{{ $t("professionalInfo.diplomas.license") }}</option>
                <option value="CAP">{{ $t("professionalInfo.diplomas.cap") }}</option>
                <option value="BTS">{{ $t("professionalInfo.diplomas.bts") }}</option>
                <option value="BTP">{{ $t("professionalInfo.diplomas.btp") }}</option>
                <option value="Other">{{ $t("professionalInfo.diplomas.other") }}</option>
              </select>
            </div>
          </div>

          <!-- Description -->
          <div class="col-12 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.description") }}
              </label>
              <textarea v-model="form.description" class="form-control" rows="3"
                        :placeholder="$t('professionalInfo.placeholders.description')"></textarea>
            </div>
          </div>

          <!-- Status -->
          <div class="col-md-6 mb-4">
            <div class="p-3 shadow-sm rounded border">
              <label class="form-label fw-bold" style="color: #b03a45;">
                {{ $t("professionalInfo.fields.status") }}
              </label>
              <select v-model="form.status" class="form-select" required>
                <option disabled value="">{{ $t("professionalInfo.placeholders.select") }}</option>
                <option value="Active">{{ $t("professionalInfo.statusOptions.active") }}</option>
                <option value="On Leave">{{ $t("professionalInfo.statusOptions.onLeave") }}</option>
                <option value="Resigned">{{ $t("professionalInfo.statusOptions.resigned") }}</option>
                <option value="Terminated">{{ $t("professionalInfo.statusOptions.terminated") }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between mt-4">
          <button type="button" class="btn btn-outline-secondary" @click="handleBack">
            {{ $t("professionalInfo.buttons.back") }}
          </button>
          <button type="submit" class="btn text-white px-4" style="background-color: #b03a45;">
            {{ $t("professionalInfo.buttons.next") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useToast } from 'vue-toastification'
import { useI18n } from 'vue-i18n'
import axios from '@/api'

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const toast = useToast()

const userId = String(route.query.user_id || '')

const form = ref({
  user_id: userId,
  company_id: '',
  project_id: '',
  position_id: '',
  manager_id: '',
  supervision_id: '',
  hire_date: '',
  status: '',
  cin: '',
  cin_release_date: '',
  code: '',
  work_number: '',
  work_email: '',
  diploma_type: '',
  description: '',
  cnss: ''
})

const companies = ref([])
const projects = ref([])
const positions = ref([])
const managers = ref([])
const supervisors = ref([])

const fetchData = async () => {
  try {
    const [companiesRes, projectsRes, positionsRes, managersRes, supervisorsRes] = await Promise.all([
      axios.get('/companies'),
      axios.get('/projects'),
      axios.get('/positions'),
      axios.get('/employee/leaves/managers'),
      axios.get('/employee/leaves/supervisors')
    ])
    companies.value = companiesRes.data
    projects.value = projectsRes.data
    positions.value = positionsRes.data
    managers.value = managersRes.data.managers
    supervisors.value = supervisorsRes.data.supervisors
  } catch (error) {
    console.error(error)
    toast.error(t("professionalInfo.messages.saveFailed"))
  }
}

const formatDate = (val) => {
  if (!val) return ''
  const date = new Date(val)
  return date.toISOString().split('T')[0]
}

const handleSubmit = async () => {
  try {
    const payload = {}
    for (const [key, value] of Object.entries(form.value)) {
      if (value !== null && value !== undefined) payload[key] = value
    }
    payload.hire_date = formatDate(payload.hire_date)
    payload.cin_release_date = formatDate(payload.cin_release_date)

   await axios.post('/employee/professional-information', payload)
toast.success(t("professionalInfo.messages.saved"))
router.push({
  path: '/employee/bank-details',
  query: { user_id: userId }
})


  } catch (error) {
    console.error(error)
    if (error.response?.status === 422) {
      const messages = Object.values(error.response.data.errors).flat().join(', ')
      toast.error(messages)
    } else {
      toast.error(t("professionalInfo.messages.saveFailed"))
    }
  }
}

const handleBack = () => {
  router.push({ path: '/employee/information', query: { user_id: userId } })
}

onMounted(fetchData)
</script>
